const HIGH_RISK_SUPPLIERS_DESCRIPTION = `This chart shows the lowest rated suppliers across your Portfolio.`;

export default HIGH_RISK_SUPPLIERS_DESCRIPTION;
